$(document).ready(function () {
    //	if (jQuery.browser.version==8.0) {
    //	   $("body").addClass("ie8");
    //	}
    $(".printQuote").click(function (e) {
        e.preventDefault();
        var url = jQuery(this).attr("href");
        window.open(
            url,
            "PopupWindow",
            "height=704,width=612,location=no,menubar=no,scrollbars=yes,status=no,toolbar=no,resizable=yes",
        );
    });
});

$.fn.digits = function () {
    return this.each(function () {
        $(this).text(
            $(this)
                .text()
                .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"),
        );
    });
};

function trimField(fld) {
    // removes leading and trailing blanks from fld
    var res = "";
    var c = 0;
    for (let i = 0; i < fld.length; i++) {
        if (fld.charAt(i) != " " || c > 0) {
            res += fld.charAt(i);
            if (fld.charAt(i) != " ") c = res.length;
        }
    }
    return res.substr(0, c);
}

export function showError(rowClass, e) {
    $("." + rowClass).addClass("error");
    $(".validationWrapper").show();
    if (e) {
        e.preventDefault();
    }
}

function conditionalClearTextbox(current, field) {
    if (current == "Enter up to 500 characters.") {
        field.value = "";
    }
}
